import { Component, EventEmitter, Output, OnInit, Input, OnDestroy, ViewChild, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-ika-personel-arama.service';
import { DxButtonModule, DxTextBoxComponent, DxTextBoxModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { debounceTime, Observable, Subject, Subscription } from 'rxjs';
import { IkaPersonelService } from '../ctl-ika-personel.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-ika-personel-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule, CommonModule,DxTextBoxModule],
  providers: [Service],
  templateUrl: './ctl-ika-personel-arama.component.html',
  styleUrls: ['./ctl-ika-personel-arama.component.scss'],
})
export class CtlIkaPersonelAramaComponent implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @ViewChild(DxTextBoxComponent) searchInput!: DxTextBoxComponent;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<any>();
    public searchValue: string= "";
    private typingSubject: Subject<string> = new Subject();
    private subscription!: Subscription;
  firstReadyCheck = true;
  constructor(
    private service: Service,
    private ikaPersonelService: IkaPersonelService,
    public ortakService: OrtakService
  ) {
  }

  ngOnInit(): void {
      this.subscription = this.typingSubject.pipe(
        debounceTime(1000)
      ).subscribe(value => {
        this.performSearch(value);
      });
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.ikaPersonelService.gridControlsList$;
    this.ikaPersonelService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x) => {
      this.columns = this.ortakService.setRecursiveFieldData([x], false);
    });
  }

onContentReady(e: any) {
  if(this.firstReadyCheck){
    setTimeout(() => {
      this.searchInput.instance.focus();
      this.firstReadyCheck = false;
    }, 300);
  }
}

  onKeyInput(e: any) {
    const currentValue = e.event.target.value;
    this.typingSubject.next(currentValue);
  }

  performSearch(value: string) {
    this.data = this.service.getData(this.control,value);
  }

  customSearch(e:any){
    this.data = this.service.getData(this.control,e);
  }
  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
